<div class="d-flex h-100 pointer align-items-center" *ngIf="!isOpen" (click)="isOpen = true">
  <i class="icon-burger-menu"></i>
</div>
<div *ngIf="isOpen" class="position-fixed fixed-top p-3">
  <div class="text-end" (click)="isOpen = false">
    <i class="icon-close"></i>
  </div>
  <div class="menu-items font-2xl">
    <div class="menu-item"
         *ngIf="giftCardsEnabled"
         [translate]="'orderProcess.cakesOverview.header.giftCards'"
         (click)="goToGiftCards(); isOpen = false;">Gift cards
    </div>
    <div class="menu-item how-it-works-menu-item"
         [translate]="'orderProcess.cakesOverview.header.howItWorks'"
         (click)="showHowItWorks(); isOpen = false;">How it works
    </div>
    <div class="menu-item"
         [translate]="'orderProcess.cakesOverview.header.needHelp'"
         (click)="showContactUs(); isOpen = false;">Help?
    </div>
    <ng-container *ngIf="user">
      <div class="menu-item"
           (click)="goToMyAccount(); isOpen = false;"
           [translate]="'orderProcess.cakesOverview.header.myProfile'">My profile
      </div>
      <div class="menu-item"
           (click)="logout(); isOpen = false;"
           [translate]="'profile.menu.logout'">Log out
      </div>
    </ng-container>

    <ng-container *ngIf="!user">
      <div class="menu-item"
           (click)="showLogin(); isOpen = false;"
           [translate]="'auth.topHeader.login'">Log in
      </div>
    </ng-container>
  </div>
</div>
